import PrivilegedRoute from './routing/PrivilegedRoute'
import Login from './Login'

export { PrivilegedRoute, Login }



// WEBPACK FOOTER //
// ./src/components/index.js